import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 83A1C782-63D7-476B-8A6D-A694F29AE3A9
 * name location-exit
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/location-exit.svg
 * tags
 * - Home Automation 
 */
export const LocationExitIcon = createSvgIcon(<><path d="M22 12L18 8V11H10V13H18V16M20 18A10 10 0 1 1 20 6H17.27A8 8 0 1 0 17.27 18Z" /></>, 'LocationExitIcon');
export default LocationExitIcon